export default __webpack_public_path__ + "static/media/gooil-logo.e42d7ca0.png";